// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"881c27a8","252":"5b3ec382","317":"d9f7ee81","345":"f909efdb","397":"cd697e01","488":"7f64e021","518":"a9e55bdd","628":"af5a5609","707":"9ebc10cd","940":"e9dddd7f"}[chunkId] + ".chunk.js";
};